import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://khushhali.com/api/seller",
    // baseUrl: "http://127.0.0.1:5173/api/seller",
    prepareHeaders: (headers, { getState }) => {
      const token = getState().counter.accessToken;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["SalesProducts"],
  endpoints: (builder) => ({
    loginSeller: builder.mutation({
      query: ({ email, password }) => ({
        url: "/signin",
        method: "POST",
        body: { email, password },
      }),
    }),

    registerSeller: builder.mutation({
      query: (formData) => ({
        url: "/signup",
        method: "POST",
        body: formData,
        formData: true,
      }),
    }),
    getaccessToken: builder.mutation({
      query: (body) => ({
        url: "/refreshToken",
        method: "POST",
        body: body,
      }),
    }),
    submitSellerVerification: builder.mutation({
      query: (formData) => ({
        url: "/seller-verification",
        method: "POST",
        body: formData,
      }),
    }),

    postProduct: builder.mutation({
      query: (productData) => ({
        url: "/products",
        method: "POST",
        body: productData,
      }),
    }),
    updateProduct: builder.mutation({
      query: ({ productId, productData }) => ({
        url: `/products?productId=${productId}`,
        method: "PATCH",
        body: productData,
      }),
    }),

    dashboardStats: builder.query({
      query: () => ({
        url: "/dashboard",
        method: "GET",
      }),
    }),

    getOrders: builder.query({
      query: ({ page = 1, limit = 10 }) => ({
        url: `/orders?page=${page}&limit=${limit}`,
        method: "GET",
      }),
    }),
    getProducts: builder.query({
      query: ({ page = 1, limit = 10 }) => ({
        url: "/products",
        method: "GET",
        params: { page, limit },
      }),
    }),
    getSeller: builder.query({
      query: () => ({
        url: "/",
        method: "GET",
      }),
    }),

    getSales: builder.query({
      query: ({ page = 1, limit = 10 }) => ({
        url: `/sales?page=${page}&limit=${limit}`,
        method: "GET",
      }),
    }),

    getBalance: builder.query({
      query: () => ({
        url: "/balance",
        method: "GET",
      }),
    }),
    addProductToSales: builder.mutation({
      query: (body) => ({
        url: "/sales",
        method: "POST",
        body: body,
      }),
      invalidatesTags: ["SalesProducts"],
    }),

    getActiveSellerProducts: builder.query({
      query: (page = 1, limit = 10) => {
        console.log("Testing Function");

        return `/products/active?page=${page}&limit=${limit}`;
      },
    }),

    getSalesProducts: builder.query({
      query: ({ salesId, page = 1, limit = 10 }) =>
        `/sale?sales=${salesId}&page=${page}&limit=${limit}`,
      providesTags: ["SalesProducts"],
    }),
    getProductById: builder.query({
      query: (productId) => ({
        url: `/products?productId=${productId}`,
        method: "GET",
      }),
    }),
    deleteProduct: builder.mutation({
      query: (id) => ({
        url: `/products/?id=${id}`,
        method: "DELETE",
      }),
    }),

    restoreProduct: builder.mutation({
      query: (productId) => ({
        url: `/product/restore?id=${productId}`,
        method: "PATCH",
      }),
    }),

    removeProductFromSales: builder.mutation({
      query: ({ productId, salesId }) => ({
        url: `/sales`,
        method: "DELETE",
        body: { productId, salesId },
      }),
    }),

    getSellerMessages: builder.query({
      query: () => ({
        url: "/messages",
        method: "GET",
      }),
      transformResponse: (response) => {
        if (response?.status && Array.isArray(response.data)) {
          return response.data.map((item) => ({
            id: item.id,
            username: item.user?.username || "Unknown User",
            image: item.user?.image || null,
            unreadCount: item._count?.messages || 0,
          }));
        }
        return [];
      },
    }),

    getChatMessages: builder.query({
      query: ({ conversationId, page = 1, limit = 10 }) => ({
        url: `/messages/chat`,
        method: "GET",
        params: { conversationId, page, limit },
      }),
      providesTags: ["Chat"],
    }),

    sendMessage: builder.mutation({
      query: (body) => ({
        url: "/messages",
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "Chat", id: arg.conversationId ?? 1 },
      ],
    }),
    getCategoris: builder.query({
      query: () => ({
        url: `/categories`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useLoginSellerMutation,
  useRegisterSellerMutation,
  useSubmitSellerVerificationMutation,
  usePostProductMutation,
  useDashboardStatsQuery,
  useGetOrdersQuery,
  useGetProductsQuery,
  useGetSellerQuery,
  useGetaccessTokenMutation,
  useGetActiveSellerProductsQuery,
  useAddProductToSalesMutation,
  useGetSalesProductsQuery,
  useDeleteProductMutation,
  useRestoreProductMutation,
  useRemoveProductFromSalesMutation,
  useGetSalesQuery,
  useGetBalanceQuery,
  useGetSellerMessagesQuery,
  useGetChatMessagesQuery,
  useSendMessageMutation,
  useGetCategorisQuery,
  useGetProductByIdQuery,
  useUpdateProductMutation,
} = apiSlice;
